import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone } from '@fortawesome/pro-solid-svg-icons/faClone'
import { faPollH } from '@fortawesome/pro-solid-svg-icons/faPollH'
import { useTranslation } from 'react-i18next'
import { TRANSLATION_PREFIX } from 'pages/administration/SurveyBank/constants'
import { Grid, Heading, Hint, Icon, PathCard, Title } from './styled'

export type SurveyStartPathValue = 'template' | 'create'

interface IProps {
  value: SurveyStartPathValue | null
  onChange: (value: SurveyStartPathValue) => void
}

/** First choice when creating a course survey: use a template or start empty. */
export const SurveyStartPath = ({ value, onChange }: IProps) => {
  const { t } = useTranslation()
  const prefix = `${TRANSLATION_PREFIX}.block.start`

  return (
    <div data-testid="survey-block-start">
      <Heading>{t(`${prefix}.heading`)}</Heading>
      <Grid role="radiogroup" aria-label={t(`${prefix}.heading`)}>
        <PathCard
          type="button"
          role="radio"
          aria-checked={value === 'template'}
          $selected={value === 'template'}
          data-testid="survey-block-use-bank"
          onClick={() => onChange('template')}
        >
          <Icon>
            <FontAwesomeIcon icon={faClone} />
          </Icon>
          <Title>{t(`${prefix}.useTemplate`)}</Title>
          <Hint>{t(`${prefix}.useTemplateHint`)}</Hint>
        </PathCard>
        <PathCard
          type="button"
          role="radio"
          aria-checked={value === 'create'}
          $selected={value === 'create'}
          data-testid="survey-block-start-create"
          onClick={() => onChange('create')}
        >
          <Icon>
            <FontAwesomeIcon icon={faPollH} />
          </Icon>
          <Title>{t(`${prefix}.create`)}</Title>
          <Hint>{t(`${prefix}.createHint`)}</Hint>
        </PathCard>
      </Grid>
    </div>
  )
}
